<div class="stats-section">
  <span class="stats-ellipsis">...</span>
  <span class="stats-info">
    <b>{{getNumberOfSections()}}</b> {{"courses.embed.moreSections" | translate}}, <b>{{getTotalLessons()}}</b> {{"courses.embed.totalLessons" | translate}}
    </span>
  <button *ngIf="!data?.course?.free">{{ "courses.embed.viewCourseContent" | translate}}</button>
  <button *ngIf="data?.course?.free" class="free-course-btn" mat-raised-button>
    <span class="material-symbols-outlined"> play_circle </span>
    {{"course.courseActionButtons.claimFreeCourse" | translate}}
  </button>
</div>
